import {Field} from 'formik';
import {Stack} from '@mantine/core';
import {FormikSelect, FormikTextInput} from '@flexinet/ui-components';

// FNP-536 / FNP-594: backend-supported filters (UsageEventsFilterInput = accountId,
// customerId, meterCode, unresolvedCustomer, unmetered). The two booleans only narrow
// server-side in their truthy ('true') case — buildQueryFilter drops falsy values — so
// each is an "All / Yes" select (the "why didn't this bill?" toggles), not a tri-state.
const yesOnlyOptions = [
    {value: '', label: 'All'},
    {value: 'true', label: 'Yes'},
];

export const FilterFormComponent = () => {
    return (
        <Stack gap='md' my='md'>
            <Field
                name='meterCode'
                label='Meter Code'
                placeholder='e.g. email.sent'
                component={FormikTextInput}
            />
            <Field
                name='customerId'
                label='Customer ID'
                component={FormikTextInput}
            />
            <Field
                name='accountId'
                label='Account ID'
                component={FormikTextInput}
            />
            <Field
                name='unresolvedCustomer'
                label='Unresolved Customer'
                description='Events whose paying customer is not yet resolved.'
                data={yesOnlyOptions}
                component={FormikSelect}
            />
            <Field
                name='unmetered'
                label='Unmetered'
                description='Events whose meter code is not in the catalog.'
                data={yesOnlyOptions}
                component={FormikSelect}
            />
        </Stack>
    );
};
